import { CLASS_NAME_DEFAULT } from "../../constants"
import { BadgeProps } from "../../../types"

type WrapperProps = {
  children: React.ReactNode
  className?: string
  variant: "danger" | "success" | "warning" | "info" | "disabled" | "alt"
}

const Wrapper = ({
  children,
  variant,
  className = CLASS_NAME_DEFAULT
}: WrapperProps) => (
  <span className={`badge badge-${variant} ${className}`}>{children}</span>
)

export const BadgeDanger = (props: BadgeProps) => {
  return <Wrapper {...props} variant="danger" />
}

export const BadgeInfo = (props: BadgeProps) => {
  return <Wrapper {...props} variant="info" />
}

export const BadgeWarning = (props: BadgeProps) => {
  return <Wrapper {...props} variant="warning" />
}

export const BadgeSuccess = (props: BadgeProps) => {
  return <Wrapper {...props} variant="success" />
}

export const BadgeDisabled = (props: BadgeProps) => {
  return <Wrapper {...props} variant="disabled" />
}

export const BadgeAlt = (props: BadgeProps) => {
  return <Wrapper {...props} variant="alt" />
}

type BadgeDefaultExport = {
  /** @deprecated Use `BadgeDanger` */
  Danger: typeof BadgeDanger
  /** @deprecated Use `BadgeInfo` */
  Info: typeof BadgeInfo
  /** @deprecated Use `BadgeWarning` */
  Warning: typeof BadgeWarning
  /** @deprecated Use `BadgeSuccess` */
  Success: typeof BadgeSuccess
  /** @deprecated Use `BadgeDisabled` */
  Disabled: typeof BadgeDisabled
  /** @deprecated Use `BadgeAlt` */
  Alt: typeof BadgeAlt
}

const Badge: BadgeDefaultExport = {
  Danger: BadgeDanger,
  Info: BadgeInfo,
  Warning: BadgeWarning,
  Success: BadgeSuccess,
  Disabled: BadgeDisabled,
  Alt: BadgeAlt
}

export default Badge
